import NativeNextLink from "next/link";
import React from "react";

import type { ILinkComponentProps } from "../common/routing/types";

export interface INextLinkProps extends ILinkComponentProps {
  prefetch?: boolean | "auto" | null;
  onNavigate?: () => void;
}

export const NextLink: React.FC<INextLinkProps> = (props) => {
  const { innerRef, to, ...otherProps } = props;
  return <NativeNextLink ref={innerRef} href={to} {...otherProps} />;
};
